import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    CircularProgress
} from "@mui/material";

// Components
import Icon from "@/theme/vectors/bundle";

const DeleteConfirmationDialog = ({ open, filename, onClose, onDelete, isLoading = false, t }) => {
    return (
        <Dialog
            open={open}
            onClose={isLoading ? null : onClose}
            aria-labelledby="delete-dialog-title"
            aria-describedby="delete-dialog-description"
        >
            <DialogTitle id="delete-dialog-title">
                {t('product.detail.confirmDelete', 'Confirm Delete')}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="delete-dialog-description">
                    {t('product.detail.deleteConfirmMessage', 'Are you sure you want to delete this media?')}: <strong>{filename}</strong>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" disabled={isLoading}>
                    {t('common.cancel', 'Cancel')}
                </Button>
                <Button 
                    onClick={onDelete} 
                    color="error" 
                    variant="contained"
                    startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <Icon name="trash" />}
                    disabled={isLoading}
                    autoFocus
                >
                    {isLoading ? t('common.processing', 'Processing...') : t('common.delete', 'Delete')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmationDialog;